<template>
  <v-container id="docForm">
    <v-row dense id="po" class="subtitle-2 text--primary">
      <v-col cols="3">
        <span style="font-weight: bold; font-size: 16px"
          >Journal#: {{ DocNum }}</span
        >
      </v-col>

      <v-col cols="3" offset-md="6"> Date: {{ ojdtRecord.DocDate }} </v-col>

      <v-col cols="12">
        <v-data-table
          light
          dense
          :items-per-page="pageItems"
          :headers="headers"
          :items="orderItems"
          item-key="LineNum"
          hide-default-footer
          disable-sort
          show-select
          single-select
          @item-selected="selectedRow"
        >
          <template v-slot:item.Name="{ item }">
            <v-autocomplete
              style="min-width: 250px"
              autocomplete="off"
              dense
              outlined
              single-line
              v-model="item.Account"
              :items="accounts"
              label="Select Account"
              item-text="Name"
              item-value="id"
              @change="setOrderItem(item)"
            >
              <template v-slot:no-data>
                <v-row align="center" justify="center">
                  <v-btn
                    class="ma-2"
                    color="accent"
                    dark
                    small
                    elevation="0"
                    @click="openCreate()"
                  >
                    <v-icon left>mdi-plus</v-icon>Create Account
                  </v-btn>
                </v-row>
              </template>
            </v-autocomplete>
          </template>

          <template v-slot:item.Debit="{ item }">
            <v-text-field
              autocomplete="off"
              type="number"
              style="min-width: 100px"
              class="orderInput"
              single-line
              outlined
              dense
              v-model="item.Debit"
            ></v-text-field>
          </template>

          <template v-slot:item.Credit="{ item }">
            <v-text-field
              autocomplete="off"
              type="number"
              style="min-width: 100px"
              class="orderInput"
              single-line
              outlined
              dense
              v-model="item.Credit"
            ></v-text-field>
          </template>

          <template v-slot:item.Remarks="{ item }">
            <v-text-field
              autocomplete="off"
              type="text"
              style="min-width: 280px"
              class="orderInput"
              single-line
              outlined
              dense
              v-model="item.Remarks"
            ></v-text-field>
          </template>
        </v-data-table>

        <!-- Totals table -->
        <v-data-table
          light
          dense
          :items-per-page="pageItems"
          :headers="totalHeaders"
          :items="totalsData"
          item-key="LineNum"
          hide-default-footer
          hide-default-header
        >
          <template v-slot:item.Name="{ item }">
            <div
              style="
                font-size: 16px;
                font-weight: bold;
                min-width: 110px;
                float: right;
                color: #696969;
              "
            >
              Totals:
            </div>
          </template>

          <template v-slot:item.Debit="{ item }">
            <div
              style="
                min-width: 70px;
                font-size: 16px;
                font-weight: bold;
                color: #696969;
              "
            >
              DR: {{ totalDebit.toLocaleString() }}
            </div>
          </template>

          <template v-slot:item.Credit="{ item }">
            <div
              style="
                min-width: 100px;
                font-size: 16px;
                font-weight: bold;
                color: #696969;
              "
            >
              CR: {{ totalCredit.toLocaleString() }}
            </div>
          </template>

          <template v-slot:item.Memo="{ item }">
            <div style="min-width: 70px"></div>
          </template>

          <template v-slot:item.Balance="{ item }">
            <div style="min-width: 50px"></div>
          </template>
        </v-data-table>
        <!-- end -->
      </v-col>
    </v-row>

    <v-row class="subtitle-2 text--primary flex justify-end">
      <v-col cols="12" class="d-flex justify-end">
        <v-btn color="accent" @click="sendData" :loading="loader">
          <v-icon left>mdi-content-save</v-icon> Update
        </v-btn>
      </v-col>
    </v-row>

    <!-- Account quick add dialog -->
    <v-dialog v-model="accountDialog" max-width="650px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create Account</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="accountDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <account-editor
              :initial="customerItem"
              @data="saveAccount"
            ></account-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>


<script>
import AccountEditor from "@/components/subscriber/accounts/_components/quick-editor.vue";
export default {
  components: {
    AccountEditor,
  },
  props: {
    docCreate: {
      type: Boolean,
    },
    loaderOff: {
      type: Boolean,
    },
    copyStatus: {
      type: Boolean,
    },
    initial: {
      type: Object,
    },
  },
  data: () => ({
    record: {},
    accountItem: {},
    quickItem: {},
    enableCreate: true,
    searchingProduct: false,
    UserSign: null,
    deleteName: null,
    deleteDialog: false,
    activeDeleteRow: {},
    enablePriceList: "N",
    ref2: null,
    IMEI: null,
    SoldBy: null,
    loader: false,
    pageItems: 100,
    DiscOnTotal: null,
    AmountGiven: null,
    multiplePayment: "Y",
    selectedProduct: null,
    SumApplied: null,
    DocNum: null,
    selectedItems: [],
    activeRow: null,
    storeId: null,
    singleSelect: true,
    paymentItem: {},
    ojdtRecord: {},
    paymentDialog: false,
    changeCash: 0,
    payments: [],
    orderItems: [],
    customers: [],
    products: [],
    accounts: [],
    taxGroups: [],
    accountBalances: [],
    stores: [],
    users: [],
    accountDialog: false,
    date: null,
    totalsData: [{ Name: "", Debit: "", Credit: "", Memo: "", balance: "" }],
    headers: [
      { text: "Account", value: "Name" },
      { text: "Debit", value: "Debit" },
      { text: "Credit", value: "Credit" },
      // { text: "Delete", value: "action" }
    ],
    totalHeaders: [
      { text: "Account", value: "Name" },
      { text: "Debit", value: "Debit" },
      { text: "Credit", value: "Credit" },
      { text: "Memo", value: "Memo" },
      { text: "Acc. Balance", value: "Balance" },
      // { text: "Delete", value: "action" }
    ],
  }),
  computed: {
    userName() {
      return localStorage.getItem("userName");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    totalCredit() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map((item) => {
            const amount = item.Credit;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    totalDebit() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map((item) => {
            const amount = item.Debit;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
  },
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.ojdtRecord = { ...val };
      if (val.rows) {
        this.orderItems = [...val.rows];
      }
    },
    openCreate(data) {
      this.quickItem = data;
      this.accountDialog = true;
    },
    quickAdd(account) {
      this.accounts = [...this.accounts, account];
      this.$refs.snackbar.show("Account Added Successully", "green");
    },
    saveAccount(data) {
      const url = "/accounts";
      const self = this;
      self.$store.commit("btnLoader", true);
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.quickAdd(res.ResponseData);
            self.loader = false;
            self.$store.commit("btnLoader", false);
            self.accountDialog = false;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(date) {
      this.date = date;
    },
    deleteRow(item) {
      const selectedRow = this.orderItems.find((record) => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.orderItems.splice(pos, 1);
      this.activeRow = null;
      this.selectedItems = [];
      this.deleteDialog = false;
    },
    selectedRow($event) {
      this.activeDeleteRow = $event.item;
      this.deleteDialog = true;
    },
    setOrderItem(data) {
      const accountId = data.id;
      const oactBalance = this.accountBalances.find((record) => {
        return record.Account == accountId;
      });
      const store_id = this.activeStore;
      // current item definition
      const currentItem = this.orderItems.find((record) => {
        return record.LineNum === data.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      currentItem.store_id = store_id;
      currentItem.Balance = oactBalance.Balance;
      this.orderItems[pos] = currentItem;
    },
    sendData() {
      if (this.orderItems.length > 0) {
        let data = {};
        data.ojdtId = this.ojdtRecord.id;
        data.rows = this.orderItems;
        data.totalCredit = this.totalCredit;
        data.totalDebit = this.totalDebit;
        data.DocDate = this.date;
        if (this.totalCredit != this.totalDebit) {
          this.$refs.snackbar.show("Debit must be equal to credit", "red");
        } else {
          // save data
          const url = "/edit-journal-entry";
          const self = this;
          self.loader = true;
          this.$store
            .dispatch("post", { url, data })
            .then((res) => {
              if (res.ResultCode == 1200) {
                self.getDocNum();
                self.date = null;
                self.loader = false;
                self.orderItems = [];
                this.$refs.snackbar.show("Posted Successfully", "green");
                self.date = null;
                self.record = {};
                self.$router.push(`/edit/journal/entry/${res.ResponseData.id}`);
              } else {
                self.loader = false;
                this.$refs.snackbar.show(res.ResultDesc, "red");
              }
            })
            .catch((err) => {
              self.loader = false;
              this.$refs.snackbar.show(err, "red");
            });
          // end
        }
      } else {
        this.$refs.snackbar.show("You must have at least one entry", "red");
      }
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/14`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.DocNum = res.ResponseData.NextNumber;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    addRow() {
      let initArray = [];
      const LineNum = new Date().getTime();
      const details = {
        LineNum: LineNum,
        Name: null,
        Credit: null,
        Debit: null,
        Balance: null,
        Memo: null,
      };
      initArray.push(details);
      this.orderItems = [...this.orderItems, ...initArray];
    },
    getAccountBalances() {
      const self = this;
      this.$store
        .dispatch("get", `/account-balances`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accountBalances = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([
      this.getDocNum(),
      this.getAccounts(),
      this.getAccountBalances(),
    ]);
  },
};
</script>

<style lang="scss" scoped>
.genFont {
  font-size: 1.3em;
  font-weight: 500;
}
</style>